import styled, { createGlobalStyle } from 'styled-components'
import { defaultTheme } from '../../../../../../src/theme'

export const ReceiptGlobalPrintStyle = createGlobalStyle`
  @media print {
    @page {
      size: letter;
      margin: 0.45in 0.4in 0.65in 0.4in;
    }

    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`

export const SectionTitle = styled.div`
  font-family: Oswald, serif;
  font-weight: 700;
  font-size: 11pt;
  line-height: 14pt;
  text-transform: uppercase;
  background-color: ${defaultTheme.colors.rowFeaturedBackground};
  padding: 4px 6px;
`

export const ReceiptTableGrid = styled.div<{ $columns: string }>`
  display: grid;
  grid-template-columns: ${(p) => p.$columns};
  width: 100%;
`

interface ReceiptCellProps {
  $span?: number
  $align?: 'start' | 'end' | 'center'
  $header?: boolean
}

export const ReceiptCell = styled.div<ReceiptCellProps>`
  display: flex;
  flex-direction: column;
  align-items: ${(p) =>
    p.$align === 'start'
      ? 'flex-start'
      : p.$align === 'center'
        ? 'center'
        : 'flex-end'};
  justify-content: ${(p) => (p.$header ? 'center' : 'flex-start')};
  font-weight: ${(p) => (p.$header ? 700 : 400)};
  font-size: 11pt;
  line-height: 14pt;
  grid-column: span ${(p) => p.$span ?? 1};
  padding: 3px 4px;
  border-bottom: 1px solid ${defaultTheme.colors.disabledBackground};
  text-transform: ${(p) => (p.$header ? 'uppercase' : 'none')};
  background-color: ${(p) =>
    p.$header ? defaultTheme.colors.rowFeaturedBackground : 'transparent'};
  word-break: break-word;
`

export const ReceiptTextRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 6px;
  font-size: 11pt;
  line-height: 14pt;
  padding: 2px 4px;
`

export const ReceiptLabel = styled.span`
  font-weight: 700;
`

export const ReceiptValue = styled.span`
  font-weight: 400;
`

export const ReceiptDivider = styled.span`
  color: ${defaultTheme.colors.greyBorder};
  margin: 0 2px;
`
